module.exports = __webpack_public_path__ + "img/money-wallet.eae50cf6.svg";